
import React, { useState, useEffect, useRef, useCallback, useMemo, } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import {
    Box, Avatar, Accordion,
    AccordionSummary,
    AccordionDetails, Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Breadcrumbs, Link,
} from "@mui/material";
import { Menu as MenuIcon, Help as HelpIcon } from '@mui/icons-material';
import { Typography, Card, Chip, IconButton, CardContent, Paper, Container, Tooltip as TooltipCustom, useMediaQuery, Backdrop, CircularProgress, useTheme, Stack } from '@mui/material';
// Material Dashboard 3 PRO React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMaterialUIController, setMiniSidenav } from "context";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import ArrowDropUpRoundedIcon from "@mui/icons-material/ArrowDropUpRounded";
import Banner1 from "assets/images/Retailers/7-Eleven-Logo-11.png";
import './retails.css'
import KpiMetricscards from "components/KPI/KpiMetricscards";
import TimeSeriescards from "components/TimeSeries/TimeSeriescards";
import HighlightsCards from "components/Highlights/Highlightscard";
import PieLegendCard from "components/Visualizations/Piecharts"
import Barcharts from "components/Visualizations/Barcharts"
import Map from 'components/Visualizations/Map'
import LineChartSubBrand from "components/Visualizations/Linechartsubbrand";
import TopSkuBarChart from "components/Visualizations/SkuBarchart";
import LineChartsale from "components/Visualizations/LineChartsale"
import InventoryCharts from "components/Visualizations/Inventorycharts";
import WaterfallChart from "components/Visualizations/waterfallchart";
import DoubleBarChart from "components/Visualizations/DoubleBarcharts";
import BrandPriceDumbbellChart from "components/Visualizations/DumbleBarchart";
import AppHeader from "components/Header/AppHeader";
import MDBox from "components/MDBox";
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import FilterChip from "components/FilterChip/FilterChip";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

import Datamap from "./Datamap";

function RetailsDetailspage({ subcategoryToken }) {

    const [controller, dispatch] = useMaterialUIController();
    const { miniSidenav } = controller;
    const location = useLocation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md')); // Below 900px
    const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg')); // Between 900px and 1200px

    // State for API data

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    /* FIX leaflet marker icon */
    /* ===== EXACT PIN SVG (MATCHES IMAGE) ===== */
    const pinIcon = new L.Icon({
        iconUrl:
            "data:image/svg+xml;utf8,\
<svg xmlns='http://www.w3.org/2000/svg' width='32' height='42' viewBox='0 0 32 42'>\
<path d='M16 0C7.2 0 0 7.2 0 16c0 11.8 16 26 16 26s16-14.2 16-26C32 7.2 24.8 0 16 0z' fill='%236bb6ff'/>\
<circle cx='16' cy='16' r='6' fill='white'/>\
</svg>",
        iconSize: [32, 42],
        iconAnchor: [16, 42],
        popupAnchor: [0, -36],
    });

    const CITY_COORDS = {
        "Coal Valley,IL": [41.4286, -90.4607],
        "East Moline,IL": [41.5009, -90.4446],
        "St Louis,MO": [38.6270, -90.1994],
        "St Peters,MO": [38.7875, -90.6299],
        "Kansas City,MO": [39.0997, -94.5786],
        "Salt Lake City,UT": [40.7608, -111.8910],
        "Denver,CO": [39.7392, -104.9903],
        "Colorado Springs,CO": [38.8339, -104.8214],
        "Aurora,CO": [39.7294, -104.8319],
        "Tucson,AZ": [32.2226, -110.9747],
        "Phoenix,AZ": [33.4484, -112.0740],
        "Scottsdale,AZ": [33.4942, -111.9261],
        "Olathe,KS": [38.8814, -94.8191],
        "Lakewood,CO": [39.7047, -105.0814],
        "Moline,IL": [41.5067, -90.5151],
        "Provo,UT": [40.2338, -111.6585],
        "Tempe,AZ": [33.4255, -111.9400],
        "Mesa,AZ": [33.4152, -111.8315],
        "Westminster,CO": [39.8367, -105.0372],

        "Pittsburgh,PA": [40.4406, -79.9959],
        "Charleston,WV": [38.3498, -81.6326],
        "Troy,MI": [42.6064, -83.1498],
        "Detroit,MI": [42.3314, -83.0458],
        "Harrisburg,PA": [40.2732, -76.8867],
        "Butler,PA": [40.8612, -79.8953],
        "Ann Arbor,MI": [42.2808, -83.7430],
        "Toledo,OH": [41.6528, -83.5379],
        "Akron,OH": [41.0814, -81.5190],
        "Bethlehem,PA": [40.6259, -75.3705],
        "Virginia Beach,VA": [36.8529, -75.9780],
        "Asbury Park,NJ": [40.2204, -74.0121],
        "Herndon,VA": [38.9696, -77.3861],
        "Chicago,IL": [41.8781, -87.6298],
        "Richmond,VA": [37.5407, -77.4360],
        "Baltimore,MD": [39.2904, -76.6122],
        "Dover,DE": [39.1582, -75.5244],
        "Newark,DE": [39.6837, -75.7497],
        "Philadelphia,PA": [39.9526, -75.1652],
        "Washington,DC": [38.9072, -77.0369],

        "New York,NY": [40.7128, -74.0060],
        "Kew Gardens,NY": [40.7096, -73.8304],
        "Massapequa,NY": [40.6804, -73.4743],
        "Latham,NY": [42.7470, -73.7590],
        "Boston,MA": [42.3601, -71.0589],
        "Danbury,CT": [41.3948, -73.4540],
        "Nashua,NH": [42.7654, -71.4676],
        "Portland,ME": [43.6591, -70.2568],
        "Providence,RI": [41.8240, -71.4128],
        "Rochelle Park,NJ": [40.9073, -74.0751],
        "Brighton,MA": [42.3464, -71.1627],
        "Bondville,VT": [43.1601, -72.8284],
        "Lincoln,RI": [41.9218, -71.4695],
        "Springvale,ME": [43.4679, -70.7934],
        "Niagara Falls,NY": [43.0962, -79.0377],
        "Rochester,NY": [43.1566, -77.6088],
        "Hackensack,NJ": [40.8859, -74.0435],
        "Hartford,CT": [41.7658, -72.6734],
        "Fall River,MA": [41.7015, -71.1550],
        "Dover,NH": [43.1979, -70.8737],

        "Fort Lauderdale,FL": [26.1224, -80.1373],
        "Miami,FL": [25.7617, -80.1918],
        "Houston,TX": [29.7604, -95.3698],
        "Dallas,TX": [32.7767, -96.7970],
        "St Petersburg Beach,FL": [27.7253, -82.7412],
        "Austin,TX": [30.2672, -97.7431],
        "Charlotte,NC": [35.2271, -80.8431],
        "Oklahoma City,OK": [35.4676, -97.5164],
        "Yukon,OK": [35.5067, -97.7625],
        "Lexington,SC": [33.9815, -81.2362],
        "Lebanon,TN": [36.2081, -86.2911],
        "Nashville,TN": [36.1627, -86.7816],
        "Rock Hill,SC": [34.9249, -81.0251],
        "San Marcos,TX": [29.8833, -97.9414],
        "Largo,FL": [27.9095, -82.7873],
        "Tampa,FL": [27.9506, -82.4572],
        "Indian Trail,NC": [35.0768, -80.6698],
        "Mesquite,TX": [32.7668, -96.5992],
        "Pasadena,TX": [29.6911, -95.2091],
        "San Antonio,TX": [29.4241, -98.4936],

        "Huntington Beach,CA": [33.6595, -117.9988],
        "Costa Mesa,CA": [33.6411, -117.9187],
        "Palm Springs,CA": [33.8303, -116.5453],
        "Fresno,CA": [36.7378, -119.7871],
        "Santa Cruz,CA": [36.9741, -122.0308],
        "San Francisco,CA": [37.7749, -122.4194],
        "Pomona,CA": [34.0551, -117.7490],
        "Los Angeles,CA": [34.0522, -118.2437],
        "San Diego,CA": [32.7157, -117.1611],

        "Las Vegas,NV": [36.1699, -115.1398],
        "Portland,OR": [45.5051, -122.6750],
        "Boulder City,NV": [35.9780, -114.8329],
        "Eugene,OR": [44.0521, -123.0868],
        "Vancouver,WA": [45.6387, -122.6615],
        "Tacoma,WA": [47.2529, -122.4443],
        "Seattle,WA": [47.6062, -122.3321],
        "Reno,NV": [39.5296, -119.8138],
        "Incline Village,NV": [39.2513, -119.9729],
        "El Dorado Hills,CA": [38.6857, -121.0822],
        "Sacramento,CA": [38.5816, -121.4944],
    };



    useEffect(() => {
        const header = document.querySelector('.MuiAppBar-root');
        if (header) {
            header.style.display = 'none';
        }
    }, []);



    // Toggle sidenav from the page menu icon
    const isTogglingSidenavRef = useRef(false);
    const handleToggleSidenav = useCallback(() => {
        if (isTogglingSidenavRef.current) return;
        isTogglingSidenavRef.current = true;
        // Defer to next frame to avoid blocking heavy charts paint
        requestAnimationFrame(() => {
            setMiniSidenav(dispatch, !miniSidenav);
            setTimeout(() => {
                isTogglingSidenavRef.current = false;
            }, 150);
        });
    }, [dispatch, miniSidenav]);




    useEffect(() => {
        const fetchAllData = async () => {
            try {
                setLoading(true);


            } catch (error) {
                console.error('Failed loading static mocks or transforming data:', error);
                setError('Failed to load static mock data. Check competitive_analysis/data/allMocks.json');
            } finally {
                setLoading(false);
            }
        };

        fetchAllData();
    });


    console.log("Rendering Retailers Details Page", miniSidenav);
    const [activeIdx, setActiveIdx] = React.useState(0);
    const accordionData = [
        {
            title: "Retailer Overview",
            doors: "12,345",
            status: "Active",
            Channel: "Convenience",
            Coverage: "National",
            ParentCompany: "7-Eleven Inc.",
            RouteTomarket: "DSD"
        },
        {
            title: "TBD",
            doors: "TBD",
            status: "Active",
        },
        {
            title: "TBD",
            doors: "TBD",
            status: "Active",
        },
    ];
    const [expanded, setExpanded] = useState("panel0"); // **first card open**

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };


    const metricData = [
        { title: "Rank in Market", value: "#2", growth: "1" },
        { title: "Market Share %", value: "34%", growth: "12%" },
        { title: "Total Points of Distribution", value: "12,345", growth: "233" },
        { title: "Active SKUs", value: "22", growth: "8" },
    ];

    const stateMap = {
        AL: "Alabama",
        AK: "Alaska",
        AZ: "Arizona",
        AR: "Arkansas",
        CA: "California",
        CO: "Colorado",
        CT: "Connecticut",
        DE: "Delaware",
        FL: "Florida",
        GA: "Georgia",
        HI: "Hawaii",
        ID: "Idaho",
        IL: "Illinois",
        IN: "Indiana",
        IA: "Iowa",
        KS: "Kansas",
        KY: "Kentucky",
        LA: "Louisiana",
        ME: "Maine",
        MD: "Maryland",
        MA: "Massachusetts",
        MI: "Michigan",
        MN: "Minnesota",
        MS: "Mississippi",
        MO: "Missouri",
        MT: "Montana",
        NE: "Nebraska",
        NV: "Nevada",
        NH: "New Hampshire",
        NJ: "New Jersey",
        NM: "New Mexico",
        NY: "New York",
        NC: "North Carolina",
        ND: "North Dakota",
        OH: "Ohio",
        OK: "Oklahoma",
        OR: "Oregon",
        PA: "Pennsylvania",
        RI: "Rhode Island",
        SC: "South Carolina",
        SD: "South Dakota",
        TN: "Tennessee",
        TX: "Texas",
        UT: "Utah",
        VT: "Vermont",
        VA: "Virginia",
        WA: "Washington",
        WV: "West Virginia",
        WI: "Wisconsin",
        WY: "Wyoming",
    };
    const [formateddata, setformateddata] = useState([]);
    useEffect(() => {
        const formatted = Datamap.map(item => {
            const cityKey = `${item.City},${item.State}`;
            const coords = CITY_COORDS[cityKey];

            return {
                ...item,
                stateName: stateMap[item.State] || item.State,
                lat: coords ? coords[0] : null,
                lng: coords ? coords[1] : null,
            };
        });

        setformateddata(formatted);
    }, []);

    console.log(formateddata, "####");

    const rows1 = [
        { region: "South", division: "Sun Belt", state: "Florida", number: "3918023", address: "133 NE 2nd Ave CU1, Miami, FL 33132" },
        { region: "South", division: "Sun Belt", state: "Florida", number: "2341123", address: "9045 N Pinebrook Ave, Orlando, FL 32817" },
        { region: "South", division: "Sun Belt", state: "Florida", number: "8928128", address: "133 NE 2nd Ave CU1, Miami, FL 33132" },
        { region: "South", division: "Sun Belt", state: "Florida", number: "2313134", address: "2197 Palm Ridge Pkwy, Sarasota, FL 34231" },
        { region: "South Central", division: "Gulf", state: "Texas", number: "8927784", address: "5642 Canyon Mesa, El Paso, TX 79912" },
        { region: "South Central", division: "Gulf", state: "Texas", number: "2346619", address: "6731 Old Vista Rd, San Antonio, TX 78249" },
        { region: "South Central", division: "Gulf", state: "Texas", number: "3054212", address: "4429 Shady Arroyo Ct, Plano, TX 78414" },
    ];

    //Kpis cards data 

    const Kpiscardsdata = [
        {
            title: "Reported Dollars Sold",
            values: [
                { label: "MTD", change: "1.2%", value: "$3.68M", status: "increase" },
                { label: "QTD", change: "3.4%", value: "$11.9M", status: "increase" },
                { label: "YTD", change: "-2.1%", value: "$40.3M", status: "decrease" }
            ]
        },
        {
            title: "Reported Units Sold",
            values: [
                { label: "MTD", change: "0.8%", value: "846.1K", status: "increase" },
                { label: "QTD", change: "2.9%", value: "2.54M", status: "increase" },
                { label: "YTD", change: "-1.5%", value: "9.38M", status: "decrease" }
            ]
        },
        {
            title: "All Commodity Volume (ACV)",
            values: [
                { label: "MTD", change: "0.4%", value: "88.6%", status: "increase" },
                { label: "QTD", change: "1.1%", value: "89.1%", status: "increase" },
                { label: "YTD", change: "-0.7%", value: "89.8%", status: "decrease" }
            ]
        },
        {
            title: "Dollar Sold per Avg Weekly TPD",
            values: [
                { label: "MTD", change: "1.1%", value: "$42.7K", status: "increase" },
                { label: "QTD", change: "2.4%", value: "$282.1K", status: "increase" },
                { label: "YTD", change: "-3.9%", value: "$1.19M", status: "decrease" }
            ]
        },
        {
            title: "Units Sold per Avg Weekly TPD",
            values: [
                { label: "MTD", change: "0.9%", value: "7.9K", status: "increase" },
                { label: "QTD", change: "3.9%", value: "52.1K", status: "increase" },
                { label: "YTD", change: "-3.9%", value: "221.4K", status: "decrease" }
            ]
        },
        {
            title: "Sales Growth Rate (Dollars Sold)",
            values: [
                { label: "MTD", change: "0.6%", value: "12.8%", status: "increase" },
                { label: "QTD", change: "0.9%", value: "13.1%", status: "increase" },
                { label: "YTD", change: "-1.4%", value: "13.9%", status: "decrease" }
            ]
        },
        {
            title: "Average Price per Unit",
            values: [
                { label: "MTD", change: "0.4%", value: "$2.19", status: "increase" },
                { label: "QTD", change: "1.8%", value: "$2.23", status: "increase" },
                { label: "YTD", change: "-3.2%", value: "$2.16", status: "decrease" }
            ]
        },
        {
            title: "% Dollars Sold on Promotion",
            values: [
                { label: "MTD", change: "0.6%", value: "27.8%", status: "increase" },
                { label: "QTD", change: "1.1%", value: "28.3%", status: "increase" },
                { label: "YTD", change: "1.9%", value: "29.1%", status: "increase" }
            ]
        },
        {
            title: "% Dollars Sold on Display",
            values: [
                { label: "MTD", change: "0.6%", value: "12.8%", status: "increase" },
                { label: "QTD", change: "0.9%", value: "13.1%", status: "increase" },
                { label: "YTD", change: "-1.4%", value: "13.9%", status: "decrease" }
            ]
        }
    ];

    //second section cards
    const timeSeriesCardsdata = [
        {
            title: "Reported Dollars Sold",
            values: [
                { label: "Nov 2024", change: "+4.8%", value: "$3.51M", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "$3.68M", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+1.6%", value: "$3.62M", status: "increase", arrow: "left" }
            ]
        },
        {
            title: "Reported Units Sold",
            values: [
                { label: "Nov 2024", change: "+3.2%", value: "820.0K", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "846.1K", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "-0.4%", value: "849.5K", status: "decrease", arrow: "left" }
            ]
        },
        {
            title: "All Commodity Value (ACV)",
            values: [
                { label: "Nov 2024", change: "+1.4%", value: "88.1%", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "89.3%", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+0.2%", value: "89.1%", status: "increase", arrow: "left" }
            ]
        },
        {
            title: "Dollar Sales per Avg Weekly TPD",
            values: [
                { label: "Nov 2024", change: "+5.1%", value: "$41.9K", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "$44.1K", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+0.8%", value: "$43.7K", status: "increase", arrow: "left" }
            ]
        },
        {
            title: "Unit Sales per Avg Weekly TPD",
            values: [
                { label: "Nov 2024", change: "+4.4%", value: "7.5K", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "7.8K", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+0.5%", value: "7.76K", status: "increase", arrow: "left" }
            ]
        },
        {
            title: "Sales Growth Rate (Dollars Sold)",
            values: [
                { label: "Nov 2024", change: "+2.3%", value: "13.9%", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "14.2%", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "-1.0%", value: "14.36%", status: "decrease", arrow: "left" }
            ]
        },
        {
            title: "Average Price Per Unit",
            values: [
                { label: "Nov 2024", change: "+1.6%", value: "$2.21", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "$2.25", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+0.3%", value: "$2.24", status: "increase", arrow: "left" }
            ]
        },
        {
            title: "% Dollars Sold on Promotion",
            values: [
                { label: "Nov 2024", change: "+2.0%", value: "26.8%", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "27.3%", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+1.1%", value: "27.0%", status: "decrease", arrow: "left" }
            ]
        },
        {
            title: "% Dollars Sold on Display",
            values: [
                { label: "Nov 2024", change: "+2.0%", value: "26.8%", status: "increase", arrow: "right" },
                { label: "Nov 2025", change: null, value: "27.3%", status: "nochange", arrow: null },
                { label: "Oct 2025", change: "+1.1%", value: "27.0%", status: "decrease", arrow: "left" }
            ]
        }
    ];


    // Highlight cards data
    const highlightCards = [
        // ─── SUB BRAND BY DOLLAR SALES ───
        {
            title: "#1 Sub Brand by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "4.8M",
            topRightLabel: "NET SALES",
            topRightValue: "$19.6M",
            bigTitle: "C4 Performance",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "4.5M"
        },
        {
            title: "#2 Sub Brand by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "2.2M",
            topRightLabel: "NET SALES",
            topRightValue: "$9.4M",
            bigTitle: "C4 Ultimate",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "2.0M"
        },
        {
            title: "#3 Sub Brand by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "1.1M",
            topRightLabel: "NET SALES",
            topRightValue: "$4.2M",
            bigTitle: "Bloom Sparkling Energy",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "0.9M"
        },

        // ─── SKU BY DOLLAR SALES ───
        {
            title: "#1 SKU by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "1.9M",
            topRightLabel: "NET SALES",
            topRightValue: "$7.7M",
            bigTitle: "C4 Frozen Bombsicle 16oz",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "1.8M"
        },
        {
            title: "#2 SKU by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "1.6M",
            topRightLabel: "NET SALES",
            topRightValue: "$6.3M",
            bigTitle: "C4 Starburst Cherry 16oz",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "1.5M"
        },
        {
            title: "#3 SKU by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "1.26M",
            topRightLabel: "NET SALES",
            topRightValue: "$5.0M",
            bigTitle: "C4 Orange Slice 16oz",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "1.30M"
        },

        // ─── DIVISION BY DOLLAR SALES ───
        {
            title: "#1 Division by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "2.7M",
            topRightLabel: "NET SALES",
            topRightValue: "$11.0M",
            bigTitle: "Coastal Desert",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "2.5M"
        },
        {
            title: "#2 Division by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "2.4M",
            topRightLabel: "NET SALES",
            topRightValue: "$9.8M",
            bigTitle: "Sunbelt",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "2.3M"
        },
        {
            title: "#3 Division by Dollar Sales",
            topLeftLabel: "UNITS SOLD",
            topLeftValue: "1.9M",
            topRightLabel: "NET SALES",
            topRightValue: "$7.9M",
            bigTitle: "Northeast",
            bottomLabel: "UNITS SOLD LY",
            bottomValue: "1.8M"
        }
    ];




    const kpiBriefData = [
        {
            title: "Month",
            value: "$ 65.2 M",
            lyValue: "59.12 M",
            pct: "5.8%",
            positive: true,
            status: "increase",
            glvalue: "$ 85.5 M"
        },
        {
            title: "Quarter",
            value: "$ 180.6 M",
            lyValue: "160.29 M",
            pct: "11.9%",
            positive: true,
            status: "increase",
            glvalue: "$ 207.3 M"
        },
        {
            title: "Year",
            value: "$ 859.1 M",
            lyValue: "823.03 M",
            pct: "5.6%",
            positive: true,
            status: "increase",
            glvalue: "$ 882.8 M"
        }
    ];

    const subBrands = [
        { "label": "C4 Powder", "value": 8, "color": "#C2CF2D" },
        { "label": "C4 Smart Energy", "value": 5, "color": "#1BA4E6" },
        { "label": "C4 Ultimate", "value": 6, "color": "#1A1A1A" },
        { "label": "Cellucor", "value": 10, "color": "#747474" },
        { "label": "XTEND", "value": 8, "color": "#C5C5C5" },
        { "label": "Bloom Sparkling Energy", "value": 12, "color": "#C393E4" },
        { "label": "Bloom Pop", "value": 6, "color": "#59A671" },
        { "label": "C4 Performance", "value": 45, "color": "#ECD01C" },
    ]
    const competitors = [

        { "label": "Monster", "value": 25, "color": "#95C11F" },
        { "label": "Celsius", "value": 7, "color": "#F37021" },
        { "label": "Alani", "value": 4, "color": "#00C3DA" },
        { "label": "Ghost", "value": 3, "color": "#F9005A" },
        { "label": "C4", "value": 3, "color": "#FFD100" },
        { "label": "Rockstar", "value": 3, "color": "#FFB300" },
        { "label": "NOS", "value": 2, "color": "#0066CC" },
        { "label": "Bloom", "value": 2, "color": "#C393E4" },
        { "label": "Other", "value": 15, "color": "#000000" },
        { "label": "Red Bull", "value": 32, "color": "#DA291C" },
    ]
    const regions = [
        { "label": "West", "value": 18, "color": "#3BA73B" },
        { "label": "North", "value": 7, "color": "#B5CBEA" },
        { "label": "South", "value": 14, "color": "#9B72C2" },
        { "label": "South Central", "value": 20, "color": "#FFC081" },
        { "label": "Northeast", "value": 17, "color": "#D93737" },
        { "label": "Central", "value": 30, "color": "#DEDE96" },
    ]
    const divisions = [

        { "label": "Sunbelt", "value": 15, "color": "#1A5D2E" },
        { "label": "Northeast", "value": 11, "color": "#472167" },
        { "label": "Great Lakes", "value": 8, "color": "#5F3F1E" },
        { "label": "Mid Atlantic", "value": 7, "color": "#511B1B" },
        { "label": "Other", "value": 14, "color": "#000000" },
        { "label": "Coastal Desert", "value": 45, "color": "#1664D2" },
    ]

    const regionChartData = {
        title: "Reported Dollar Sales by Region",

        xLabels: [
            "Central",
            "North",
            "Northeast",
            "South",
            "South Central",
            "West"
        ],

        series: [
            { label: "C4 Powder", color: "#C2CF2D" },
            { label: "C4 Performance", color: "#ECD01C" },
            { label: "C4 Smart Energy", color: "#1BA4E6" },
            { label: "C4 Ultimate", color: "#1A1A1A" },
            { label: "Cellucor", color: "#747474" },
            { label: "XTEND", color: "#C5C5C5" },
            { label: "Bloom Sparkling Energy", color: "#C393E4" },
            { label: "Bloom Pop", color: "#59A671" }
        ],

        // Each row sums EXACTLY to image totals
        dataMatrix: [
            // Central = 125.2
            [10.0, 58.0, 4.2, 21.0, 8.0, 5.0, 13.0, 6.0],

            // North = 152.4
            [12.0, 72.0, 5.4, 23.0, 15.0, 6.0, 11.0, 8.0],

            // Northeast = 132.7
            [11.0, 62.0, 4.7, 19.0, 9.0, 6.0, 13.0, 8.0],

            // South = 174.5
            [16.0, 78.0, 5.5, 22.0, 14.0, 7.0, 18.0, 14.0],

            // South Central = 227.2
            [22.0, 102.0, 7.2, 27.0, 18.0, 10.0, 21.0, 20.0],

            // West = 193.6
            [18.0, 88.0, 6.6, 25.0, 17.0, 11.0, 12.0, 16.0]]
    };

    const lineChartSubBrandData = {
        title: "Reported Dollars Sold by Sub-Brand",

        xLabels: [
            "Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025",
            "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025",
            "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"
        ],

        series: [
            { label: "C4 Performance", color: "#ECD01C" },
            { label: "C4 Smart Energy", color: "#1BA4E6" },
            { label: "C4 Ultimate", color: "#1A1A1A" },
            { label: "Bloom Sparkling Energy", color: "#C393E4" },
            { label: "Bloom Pop", color: "#59A671" }
        ],

        dataMatrix: {
            actual: [
                // Dec
                [40, 10, 8, 2, 5],
                // Jan
                [43, 12, 12, 8, 7],
                // Feb
                [50, 16, 9, 4, 11],
                // Mar
                [47, 13, 14, 9, 8],
                // Apr
                [55, 15, 15, 7, 11],
                //May
                [58, 22, 25, 13, 17],
                // Jun
                [65, 25, 16, 17, 13],
                // Jul
                [58, 18, 19, 13, 16],
                // Aug
                [62, 22, 25, 15, 19],
                // Sep
                [65, 26, 20, 18, 21],
                // Oct
                [69, 31, 22, 24, 28],
                // Nov
                [73, 34, 18, 28, 31]
            ]
        }
    };

    const commodityVolumeBySubBrandData = {
        title: "All Commodity Volume by Sub-Brand",

        xLabels: [
            "Dec. 2025", "Jan. 2025", "Feb. 2025", "Mar. 2025",
            "Apr. 2025", "May. 2025", "Jun. 2025", "Jul. 2025",
            "Aug. 2025", "Sep. 2025", "Oct. 2025", "Nov. 2025"
        ],

        series: [
            { label: "C4 Performance", color: "#ECD01C" },
            { label: "C4 Smart Energy", color: "#1BA4E6" },
            { label: "C4 Ultimate", color: "#1A1A1A" },
            { label: "Bloom Sparkling Energy", color: "#C393E4" },
            { label: "Bloom Pop", color: "#59A671" }
        ],

        dataMatrix: {
            actual: [
                // Dec
                [78, 28, 43, 17, 6],
                // Jan
                [85, 31, 49, 27, 9],
                // Feb
                [87, 37, 43, 19, 15],
                // Mar
                [91, 31, 52, 27, 9],
                // Apr
                [80, 35, 52, 24, 14],
                // May
                [87, 44, 66, 30, 23],
                // Jun
                [85, 48, 54, 37, 17],
                // Jul
                [91, 39, 60, 31, 20],
                // Aug
                [75, 45, 66, 34, 25],
                // Sep
                [87, 50, 60, 37, 28],
                // Oct
                [86, 57, 63, 46, 36],
                // Nov
                [94, 60, 55, 52, 41]
            ]
        }

    };

    const topSkuChartData = {
        title: "Top 10 Ordered SKUs by Reported Dollars Sold",

        xLabels: [
            "C4 Performance – Strawberry Burst – 16oz",
            "C4 Smart Energy – Cherry Berry – 16oz",
            "Bloom Sparkling – Grapefruit – 12oz",
            "Bloom Sparkling – Berry – 12oz",
            "Bloom Sparkling – Peach – 12oz",
            "C4 Ultimate – Midnight Cherry – 16oz",
            "Bloom Pop – Blue Razz – 12oz",
            "Bloom Pop – Orange – 12oz",
            "Bloom Sparkling – Lime – 12oz",
            "C4 Performance – Frozen Bombsicle – 16oz"
        ],

        series: [
            { label: "Dollars Sold - This Period", key: "thisPeriod", color: "#0A3478" },
            { label: "Dollars Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" }
        ],

        dataMatrix: {
            actual: [
                [280, 80], // C4 Performance – Strawberry Burst
                [232, 55], // C4 Smart Energy – Cherry Berry
                [208, 62], // Bloom Sparkling – Grapefruit
                [193, 27], // Bloom Sparkling – Berry
                [155, 53], // Bloom Sparkling – Peach
                [108, 35], // C4 Ultimate – Midnight Cherry
                [101, 52], // Bloom Pop – Blue Razz
                [99, 65],  // Bloom Pop – Orange
                [75, 44],  // Bloom Sparkling – Lime
                [64, 40]   // C4 Performance – Frozen Bombsicle
            ]
        }
    };

    const bottomSkuChartData = {
        title: "Bottom 10 SKUs by Reported Dollars Sold",

        xLabels: [
            "C4 Ultimate – Citrus Blaze – 12oz",
            "C4 Ultimate – Tropic Storm – 16oz",
            "C4 Performance – Cherry Limeade – 16oz",
            "C4 Smart Energy – Strawberry Guava – 12oz",
            "C4 Smart Energy – Kiwi Lime – 12oz",
            "C4 Smart Energy – Watermelon Rush – 12oz",
            "C4 Ultimate – Neon Mango – 16oz",
            "C4 Ultimate – Berry Voltage – 16oz",
            "Bloom Sparkling – Pineapple – 12oz",
            "Bloom Pop – Tropical Citrus – 12oz"
        ],

        series: [
            { label: "Dollars Sold - This Period", key: "thisPeriod", color: "#0A3478" },
            { label: "Dollars Sold - Last Period", key: "lastPeriod", color: "#A8C4EA" }
        ],

        dataMatrix: {
            actual: [
                [1, 6],    // Citrus Blaze
                [2, 5],    // Tropic Storm
                [6, 12],   // Cherry Limeade
                [10, 11],  // Strawberry Guava
                [12, 9],   // Kiwi Lime
                [18, 19],  // Watermelon Rush
                [20, 24],  // Neon Mango
                [22, 19],  // Berry Voltage
                [26, 22],  // Bloom Sparkling – Pineapple
                [31, 24]   // Bloom Pop – Tropical Citrus
            ]
        }
    };


    const brandSalesChartData = {
        title: "Reported Dollars Sold by Brand",

        xLabels: [
            "Red Bull",
            "Monster",
            "Celsius",
            "Alani",
            "Ghost",
            "C4",
            "Rockstar",
            "NOS",
            "Reign",
            "Bloom"
        ],

        series: [
            { label: "Dollars Sold - Last Period", key: "last", color: "#8EB7DB" },
            { label: "Dollars Sold - This Period", key: "current", color: "#0A3A73" },

            // C4 custom colors
            { label: "C4 - Last Period", key: "last", color: "#D6C85F" },
            { label: "C4 - This Period", key: "current", color: "#EACF2F" },

            // Bloom custom colors
            { label: "Bloom - Last Period", key: "last", color: "#D9C3E9" },
            { label: "Bloom - This Period", key: "current", color: "#C393E4" }
        ],

        dataMatrix: {
            actual: [
                [4.1, 4.6],   // Red Bull (B$)
                [2.9, 3.3],   // Monster
                [1.0, 1.3],   // Celsius
                [0.8, 0.9],   // Alani
                [0.7, 0.8],   // Ghost
                [0.3, 0.4],   // C4 (special color)
                [0.3, 0.4],   // Rockstar
                [0.2, 0.3],   // NOS
                [0.3, 0.2],   // Reign
                [0.1, 0.2]    // Bloom (purple bars)
            ]
        }
    };

    const brandPriceComparison = {
        title: "Brand Base Price vs Promoted Price",

        xLabels: [
            "Red Bull",
            "Bloom",
            "Monster",
            "Alani",
            "Reign",
            "C4",
            "Celsius",
            "Ghost",
            "NOS",
            "Rockstar"
        ],

        // LEGEND CONFIG
        series: [
            { label: "Average Promo Price - Last Period", key: "promoLast", color: "#8C8C8C" },
            { label: "Base Price - Last Period", key: "baseLast", color: "#D8C72C" },
            { label: "Average Promo Price - This Period", key: "promoCurrent", color: "#000000" },
            { label: "Base Price - This Period", key: "baseCurrent", color: "#FFE000" }
        ],

        // DATA MATRIX (ORDER MATTERS)
        dataMatrix: {
            actual: [
                [3.05, 3.60, 3.30, 3.69], // Red Bull
                [2.82, 3.58, 2.56, 3.62], // Bloom
                [3.05, 3.52, 3.18, 3.59], // Monster
                [2.60, 3.20, 2.87, 3.23], // Alani
                [2.51, 3.25, 2.67, 3.22], // Reign
                [2.44, 3.06, 2.64, 3.17], // C4
                [2.50, 3.11, 2.61, 3.16], // Celsius
                [2.35, 2.90, 2.58, 2.99], // Ghost
                [2.37, 3.00, 2.47, 2.98], // NOS
                [2.50, 2.86, 2.46, 2.90]  // Rockstar
            ]
        },

        yTicks: [2.0, 2.5, 3.0, 3.5, 4.0, 4.5]
    };

    const usaData = {
        CA: 140,
        NV: 20,
        AZ: 60,
        OR: 40,
        WA: 70,
        NM: 30,
        TX: 160,
        OK: 50,
        AR: 25,
        LA: 40,
        MS: 35,
        AL: 25,
        GA: 60,
        FL: 55,
        SC: 45,
        NC: 70,
        TN: 50,
        KY: 40,
        VA: 35,
        WV: 20,
        MD: 15,
        PA: 65,
        NY: 75,
        NJ: 30,
        CT: 18,
        MA: 25,
        NH: 12,
        ME: 10,
        MI: 45,
        OH: 40,
        IN: 35,
        IL: 80,
        IA: 15,
        MN: 12,
        WI: 22,
        MO: 60,
        KS: 18,
        NE: 10,
        SD: 8,
        ND: 5,
        CO: 35,
        UT: 22,
        ID: 15,
        MT: 8,
        WY: 6,
        AK: 5,
        HI: 5,
    };

    const thickBorderStates = [
        "CA", "AZ", "NM", "TX", "OK", "MO", "IL",
        "IN", "KY", "TN", "GA", "NC", "VA"
    ];

    const legendData = [
        { label: "$0–$10M", color: "#C8C6C4" },
        { label: "$10M–$30M", color: "#D0EBBE" },
        { label: "$30M–$60M", color: "#B7E29A" },
        { label: "$60M–$100M", color: "#99D56F" },
        { label: "$100M–$150M", color: "#6BB542" },
        { label: "$150M+", color: "#4C8C17" }
    ];
    return (
        <DashboardLayout>
            <MDBox
                sx={{
                    display: {
                        xs: "block",
                        sm: "block",
                        md: "none",
                    },
                }}
            >
                <AppHeader />
            </MDBox>
            <Box
                sx={{
                    position: "sticky",     // better than fixed
                    top: 0,
                    zIndex: 10,
                    bottom: 0,
                    // background: "red",
                }}
            >
                <Box sx={{
                    ml: 0,
                    transition: "margin-left 0.25s ease",
                    "& .MuiBox-root": { backgroundImage: "none" }
                }} style={{
                    // backgroundColor: '#f8f9fa',
                    minHeight: '100vh',
                    padding: isMobile ? '8px' : '0px 16px 100px 16px',
                    paddingBottom: '100px',
                    fontFamily: 'inter'
                }}>
                    {/* Loading Backdrop */}
                    <Backdrop
                        open={loading}
                        sx={{
                            position: 'fixed',
                            zIndex: (theme) => theme.zIndex.drawer + 1,
                            backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        }}
                    >
                        <CircularProgress color="primary" />
                    </Backdrop>
                    {/* Header */}
                    <Box style={{ display: 'flex', alignItems: 'center', height: '68px', background: "none" }}>
                        <Box sx={{ background: "none" }}>
                            <Box sx={{ width: 48, height: 48, borderRadius: "50%", boxShadow: "0px 6px 18px rgba(0, 0, 0, 0.12)" }}>
                                <img src={Banner1} alt="Retailer Logo" style={{ width: "100%", height: "100%", objectFit: "cover", borderRadius: "50%" }} />
                            </Box>
                        </Box>
                        <Box sx={{ ml: '10px' }}>
                            <Box sx={{ background: "none", display: 'flex', flexDirection: 'column' }}>
                                <Typography sx={{ fontSize: "24px", fontWeight: 300, color: "#111111", lineHeight: "1 !important" }}>
                                    7-Eleven
                                </Typography>
                                <Typography sx={{ fontSize: "12px", color: "rgba(17, 17, 17, 0.5)", fontWeight: 300, lineHeight: "1 !important" }}>
                                    7 -Eleven Inc.
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ ml: '4px' }}>
                            <Box sx={{ display: "flex" }}>
                                <Box
                                    sx={{
                                        width: 8,
                                        height: 8,
                                        borderRadius: "50%",
                                        bgcolor: "#25A73E",
                                        boxShadow: "0px 0px 4px rgba(16, 125, 37, 0.5)",
                                        mt: '-8px'

                                        // marginTop: "1.2rem"
                                    }}
                                />
                            </Box>
                        </Box>
                    </Box>
                    {/* Blue Underline */}
                    <Box sx={{
                        width: '100%', height: '4px', background: '#115f9d', borderRadius: '0px', mb: 0, width: "calc(100% + 80px)",
                        ml: "-40px",
                        mr: "-40px",
                        position: "relative",
                        zIndex: 11,
                    }} className="gradient-line-Retailers" />
                    <Box
                        sx={{
                            height: "calc(100vh - 80px)", // adjust if header height changes
                            overflowY: "auto",
                            // px: isMobile ? 1 : 2,
                            pb: "100px",
                            /* smooth scrolling */
                            scrollBehavior: "smooth",
                            WebkitOverflowScrolling: "touch", // iOS momentum

                            /* hide scrollbar */
                            scrollbarWidth: "none",          // Firefox
                            msOverflowStyle: "none",         // IE / Edge
                            "&::-webkit-scrollbar": {
                                display: "none",               // Chrome / Safari
                            },
                        }}
                    >

                        {/* Section Title: KPI's */}
                        <Typography sx={{ fontSize: '16px', mb: 1, mt: 3, display: "flex", gap: "4px", alignItems: "center" }}>
                            <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>Retailers / </span><span style={{ fontSize: "16px", fontWeight: 200 }}>7-Eleven (#10001)</span>
                        </Typography>
                        <Box sx={{ width: '100%', height: '1px', background: "rgba(22, 114, 185, 0.1)", borderRadius: '2px', mb: 2, }} />

                        <Box sx={{ minHeight: "auto", }}>
                            <Grid container rowSpacing={2} alignItems="stretch">
                                {/* LEFT CARD – responsive */}
                                <Grid item xs={12} md={3} sx={{

                                    pl: "8px !important",          // REQUIRED

                                }} >

                                    {accordionData.map((item, index) => (
                                        <Accordion
                                            key={index}
                                            expanded={expanded === `panel${index}`}
                                            onChange={handleChange(`panel${index}`)}
                                            elevation={0}
                                            sx={{
                                                borderRadius: "12px !important",
                                                overflow: "hidden",
                                                mb: 2,
                                                boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",


                                            }}
                                        >
                                            {/* HEADER */}
                                            <AccordionSummary
                                                expandIcon={<ExpandMoreIcon sx={{ color: "#A7B2BE" }} />}
                                                sx={{
                                                    bgcolor: "#fff",
                                                    // borderBottom: "1px solid #f1f1f1",
                                                    // remove default height
                                                    minHeight: "unset",

                                                    //exact vertical padding
                                                    paddingTop: '16px',
                                                    paddingBottom: "24PX",
                                                    px: "20px",

                                                    // FIX inner content spacing
                                                    "& .MuiAccordionSummary-content": {
                                                        margin: 0
                                                    },

                                                    // also fix expanded state
                                                    "&.Mui-expanded": {
                                                        minHeight: "unset"
                                                    },
                                                    "&.Mui-expanded .MuiAccordionSummary-content": {
                                                        margin: 0
                                                    }
                                                }}
                                            >
                                                <Typography sx={{ color: "#1672B9", fontWeight: 200, fontSize: 16 }}>
                                                    {item.title}
                                                </Typography>
                                            </AccordionSummary>
                                            {/* CONTENT */}
                                            <AccordionDetails sx={{ px: 2.5, pb: "20px", pt: 0, marginBottom: miniSidenav ? "7.5rem !important" : "7.7rem !important", bgcolor: "#fff" }}>
                                                <Box>
                                                    <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Channel</Typography>
                                                    <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}> {item.Channel}</Typography>
                                                    <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Coverage</Typography>
                                                    <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.Coverage}</Typography>
                                                    <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Parent Company</Typography>
                                                    <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.ParentCompany}</Typography>
                                                    <Typography sx={{ mb: "4px", color: "#11111180", fontSize: 10, fontWeight: 200 }}>Route To market</Typography>
                                                    <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.RouteTomarket}</Typography>
                                                    {/* Number Of Doors */}
                                                    <Typography sx={{ color: "#11111180", fontSize: 10, fontWeight: 200 }}>
                                                        Number Of Doors
                                                    </Typography>
                                                    <Typography sx={{ mb: 2, fontSize: 13, fontWeight: 200, color: "#111111" }}>
                                                        {item.doors}
                                                    </Typography>
                                                    {/* Status */}
                                                    <Typography sx={{ color: "#11111180", fontSize: 10, fontWeight: 200 }}>Status</Typography>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                        <Typography sx={{ fontSize: 13, fontWeight: 200, color: "#111111" }}>{item.status}</Typography>

                                                        {item.status === "Active" && (
                                                            <Box
                                                                sx={{
                                                                    width: 8,
                                                                    height: 8,
                                                                    borderRadius: "50%",
                                                                    bgcolor: "#25A73E",
                                                                }}
                                                            />
                                                        )}
                                                    </Box>
                                                </Box>
                                            </AccordionDetails>
                                        </Accordion>
                                    ))}
                                </Grid>

                                {/* RIGHT CONTENT */}
                                <Grid item xs={12} md={9} sx={{
                                    pl: 2,
                                    // display: "flex",
                                    // flexDirection: "column",
                                    pr: '8px !important'         // REQUIRED

                                }} >
                                    <Grid container spacing={2} >
                                        {/* TOP ROW – 4 Cards */}
                                        <Grid item xs={12}>
                                            <Grid container spacing={2}>
                                                {metricData.map((item, index) => (
                                                    <Grid item xs={12} sm={6} lg={3} key={index}>
                                                        <Card
                                                            sx={{
                                                                width: "100%",
                                                                borderRadius: "12px",
                                                                padding: "12px 8px 12px 16px",
                                                                height: miniSidenav ? 'auto' : 'auto',
                                                                boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                                                                display: "flex",
                                                                flexDirection: "row",
                                                                border: "none !important",
                                                                // gap: "6px"
                                                            }}
                                                        >
                                                            <Box sx={{ width: miniSidenav ? "80%" : "82%" }}>
                                                                <Typography
                                                                    sx={{
                                                                        fontSize: miniSidenav ? 12 : 13,
                                                                        fontWeight: 300,
                                                                        color: "#1672B9",
                                                                        minHeight: miniSidenav ? 'auto' : "auto"
                                                                    }}
                                                                >
                                                                    {item.title}
                                                                </Typography>
                                                                <Box>
                                                                    <Typography sx={{ fontSize: 32, fontWeight: 500, lineHeight: 1, mt: '6px !important', color: "#111111" }}>
                                                                        {item.value}
                                                                    </Typography>
                                                                    {/* Growth Row */}
                                                                    <Box sx={{ display: "flex", alignItems: "center", mt: "6px !important" }}>
                                                                        <Chip
                                                                            icon={<ArrowDropUpIcon />}
                                                                            label={`${item.growth}`}
                                                                            sx={{
                                                                                background: "rgba(0, 143, 12, 0.25)",
                                                                                color: "#008F0C",
                                                                                fontWeight: 400,
                                                                                height: 20,
                                                                                mr: "6px",
                                                                                border: "1px solid rgba(0, 143, 12, 0.25)",

                                                                                /* IMPORTANT: remove default padding */
                                                                                padding: 0,

                                                                                /* Chip root controls left/right breathing space */
                                                                                "& .MuiChip-root": {
                                                                                    padding: 0,
                                                                                },

                                                                                /* ICON */
                                                                                "& .MuiChip-icon": {
                                                                                    fontSize: 16,
                                                                                    color: "#008F0C",
                                                                                    marginLeft: "8px",   //left space
                                                                                    marginRight: "4px",  //space between icon & value
                                                                                },

                                                                                /* LABEL */
                                                                                "& .MuiChip-label": {
                                                                                    paddingLeft: "0px !important",
                                                                                    paddingRight: "8px !important", //right space
                                                                                    fontSize: 10,
                                                                                    fontWeight: 300,
                                                                                    lineHeight: 1,
                                                                                },
                                                                            }}
                                                                        />

                                                                        <Typography
                                                                            sx={{
                                                                                fontSize: 10,
                                                                                color: "rgba(17, 17, 17, 0.25)",
                                                                                fontWeight: 300,
                                                                            }}
                                                                        >
                                                                            YTD
                                                                        </Typography>
                                                                    </Box>

                                                                </Box>

                                                            </Box>
                                                            <Box sx={{
                                                                width: miniSidenav ? "20%" : "18%", display: "flex",
                                                                alignItems: "flex-start",
                                                                justifyContent: "flex-end",
                                                            }}>
                                                                <IconButton
                                                                    size="small"
                                                                    sx={{
                                                                        width: 32,
                                                                        height: 32,
                                                                        borderRadius: "50%",
                                                                        border: "1.5px solid rgba(22, 114, 185, 0.25)",
                                                                    }}
                                                                >
                                                                    <ArrowOutwardIcon sx={{ fontSize: 16, color: "rgba(22, 114, 185, 0.25)" }} />
                                                                </IconButton>
                                                            </Box>
                                                            {/* Top Row: Title + Arrow */}
                                                            {/* <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                                        <Typography
                                                            sx={{
                                                                fontSize: 13,
                                                                fontWeight: 600,
                                                                color: "#1672B9",
                                                            }}
                                                        >
                                                            {item.title}
                                                        </Typography>
                                                        <IconButton
                                                            size="small"
                                                            sx={{
                                                                width: 32,
                                                                height: 32,
                                                                borderRadius: "50%",
                                                                border: "1px solid rgba(22, 114, 185, 0.25)",
                                                            }}
                                                        >
                                                            <ArrowOutwardIcon sx={{ fontSize: 16, color: "rgba(22, 114, 185, 0.25)" }} />
                                                        </IconButton>
                                                    </Box> */}
                                                            {/* Bottom Stats */}
                                                            {/* <Box>
                                                        <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1 }}>
                                                            {item.value}
                                                        </Typography>
                                                      
                                                        <Box sx={{ display: "flex", alignItems: "center", mt: '6px !important' }}>
                                                            <Chip
                                                                icon={<ArrowDropUpRoundedIcon />}
                                                                label={`${item.growth}`}
                                                                sx={{
                                                                    background: "rgba(0, 143, 12, 0.25)", // 25% opacity
                                                                    color: "#008F0C",
                                                                    fontWeight: 600,
                                                                    height: 24,
                                                                    mr: "6px",
                                                                    border: "1px solid rgba(0, 143, 12, 0.25)",
                                                                    // FIX: override chip icon styles
                                                                    "& .MuiChip-icon": {
                                                                        fontSize: "22px !important",      // icon size
                                                                        color: "#008F0C",
                                                                        marginLeft: '8px'
                                                                    },
                                                                    "& .MuiChip-label": {
                                                                        paddingLeft: "4px !important",
                                                                        paddingRight: "8px !important"
                                                                    }
                                                                }}
                                                            />
                                                            <Typography sx={{ fontSize: 10, color: "rgba(17, 17, 17, 0.25)" }}>YTD</Typography>
                                                        </Box>
                                                    </Box> */}
                                                        </Card>
                                                    </Grid>
                                                ))}
                                            </Grid>
                                        </Grid>

                                        {/* BOTTOM FULL WIDTH */}
                                        <Grid item xs={12} >
                                            <Card
                                                sx={{
                                                    borderRadius: "12px",
                                                    p: 2,
                                                    bgcolor: "#fff",
                                                    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.1)",
                                                    border: "none !important",
                                                    flex: 1,
                                                    display: "flex",
                                                    flexDirection: "column",
                                                }}
                                            >
                                                <Grid container spacing={2}>

                                                    {/* ---------- MAP 1 SECTION ---------- */}
                                                    <Grid item xs={12} md={6}>
                                                        <Typography
                                                            sx={{
                                                                color: "#2B9BE3",
                                                                fontWeight: 300,
                                                                fontSize: 14,
                                                                mb: 1.5,
                                                            }}
                                                        >
                                                            Active Doors Map
                                                        </Typography>

                                                        <div style={{ height: 500, width: "100%" }}>
                                                            <MapContainer
                                                                center={[39.5, -98.35]}
                                                                zoom={4}
                                                                minZoom={4}
                                                                maxZoom={6}
                                                                zoomControl={false}
                                                                scrollWheelZoom={false}
                                                                style={{ height: "100%", width: "100%" }}
                                                            >
                                                                <TileLayer
                                                                    url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
                                                                />

                                                                {Object.entries(CITY_COORDS).map(([key, coords], i) => (
                                                                    <Marker key={i} position={coords} icon={pinIcon} />
                                                                ))}
                                                            </MapContainer>
                                                        </div>
                                                    </Grid>

                                                    {/* ---------- TABLE SECTION ---------- */}
                                                    <Grid item xs={12} md={6}>
                                                        <Box sx={{ height: 500, overflowY: "auto", overflowX: "auto", mt: 4.5 }}>
                                                            {/* Header Row */}
                                                            <Box sx={{ display: "flex", borderBottom: "1px solid #1672B91A", position: "sticky", top: 0, bgcolor: "#fff", zIndex: 1, right: 0, width: 'max-content' }}>
                                                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Region</Box>
                                                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Division</Box>
                                                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>State</Box>
                                                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Number</Box>
                                                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Full Address</Box>
                                                                <Box sx={{ flex: "0 0 90px", p: 1, fontWeight: 600, fontSize: 13 }}>Locations</Box>
                                                            </Box>
                                                            {/* Data Rows */}
                                                            {formateddata.map((row, index) => (
                                                                <Box
                                                                    key={index}
                                                                    sx={{
                                                                        display: "flex",
                                                                        borderBottom: "1px solid #f0f0f0",
                                                                        "&:hover": { bgcolor: "#f9f9f9" }
                                                                    }}
                                                                >
                                                                    <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Region}</Box>
                                                                    <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Division}</Box>
                                                                    <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.stateName}</Box>
                                                                    <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Store}</Box>
                                                                    <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.Address}</Box>
                                                                    <Box sx={{ flex: "0 0 90px", p: 1, fontSize: 13 }}>{row.City}</Box>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            </Card>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Box>

                        {/* Section Title: KPI's */}
                        <Typography sx={{ fontSize: '16px', mt: 3, display: "flex", alignItems: "center", gap: '8px' }}>
                            <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>7-Eleven (#10001) / </span> <span style={{ fontSize: "16px", fontWeight: 200 }}>KPI's</span>
                        </Typography>
                        <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mt: '8px' }} />
                        <KpiMetricscards cardsData={Kpiscardsdata} kpiBriefData={kpiBriefData} />


                        {/* Section Title: Time series */}
                        <Typography sx={{ fontSize: '16px', mt: 3, display: "flex", alignItems: "center", gap: '8px' }}>
                            <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>7-Eleven (#10001) / </span><span style={{ fontSize: "16px", fontWeight: 200 }}>Time Series</span>
                        </Typography>
                        <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mt: '8px' }} />

                        <TimeSeriescards timeSeriesCards={timeSeriesCardsdata} />
                        {/* Section Title: Highlights */}
                        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: '24px' }}>
                            <Typography sx={{ fontSize: '16px' }}>
                                <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px" }}>7-Eleven (#10001) / </span> <span style={{ fontSize: "16px", fontWeight: 200 }}>Highlights</span>
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                {['YTD', 'QTD', 'MTD'].map((label, idx) => (
                                    <FilterChip
                                        key={label}
                                        label={label}
                                        idx={idx}
                                        activeIdx={activeIdx}
                                        onClick={setActiveIdx}
                                    />
                                ))}
                            </Box>
                        </Box>
                        <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mt: '8px' }} />
                        <HighlightsCards data={highlightCards} />
                        <Box sx={{ mt: 3 }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                                <Typography sx={{ fontSize: '16px' }}>
                                    <span style={{ color: "rgba(22, 114, 185, 0.5)", fontSize: "16px", fontWeight: 200 }}>7-Eleven (#10001) / </span> <span style={{ fontSize: "16px", fontWeight: 200 }}>Visualizations</span>
                                </Typography>

                                <Box sx={{ display: 'flex', gap: 1 }}>
                                    {["YTD", "QTD", "MTD"].map((label, idx) => (
                                        <FilterChip
                                            key={label}
                                            label={label}
                                            idx={idx}
                                            activeIdx={activeIdx}
                                            onClick={setActiveIdx}
                                        />
                                    ))}
                                </Box>
                            </Box>

                            <Box sx={{ width: '100%', height: '1px', background: '#1672B91A', borderRadius: '2px', mb: 0 }} />
                        </Box>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={2}
                            sx={{
                                mt: "26px !important",
                                alignItems: "stretch"   // keeps all cards same height
                            }}
                        >
                            <Grid item xs={12} sm={6} md={3} sx={{
                                pt: { xs: "0px !important", sm: "0px !important", md: "0px !important" }
                            }} >
                                <PieLegendCard title="Reported Dollars Sold by Sub Brand" data={subBrands} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3} sx={{
                                pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" }
                            }}  >
                                <PieLegendCard title="Brand Marketshare by Dollars Sold" data={competitors} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3} sx={{
                                pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" }
                            }}  >
                                <PieLegendCard title="Reported Dollars Sold by Region" data={regions} />
                            </Grid>

                            <Grid item xs={12} sm={6} md={3} sx={{
                                pt: { xs: "26px !important", sm: "26px !important", md: "0px !important" }
                            }} >
                                <PieLegendCard title="Reported Dollars Sold by Top 5 Divisions" data={divisions} />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} sx={{ mt: "10px !important" }}>
                            {/* LEFT CARD - USA MAP */}
                            <Grid item xs={12} md={4}>
                                <Map
                                    title="Reported Dollars Sold Heatmap by State"
                                    usaData={usaData}
                                    thickBorderStates={thickBorderStates}
                                    legendData={legendData}
                                />

                            </Grid>

                            {/* RIGHT CARD - BAR CHART */}
                            <Grid item xs={12} md={8}>
                                <Barcharts
                                    title={regionChartData.title}
                                    xLabels={regionChartData.xLabels}
                                    series={regionChartData.series}
                                    dataMatrix={regionChartData.dataMatrix}
                                    yTicks={[0, 50, 100, 150, 200, 250]}
                                    rounded={true}
                                    yAxisLabel="Net Sales ($M)"
                                />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ mt: "34px !important" }}>
                            <Grid item xs={12}>
                                <LineChartSubBrand
                                    title={lineChartSubBrandData.title}
                                    xLabels={lineChartSubBrandData.xLabels}
                                    series={lineChartSubBrandData.series}
                                    dataMatrix={lineChartSubBrandData.dataMatrix}
                                    yTicks={[0, 15, 30, 45, 60, 75]}
                                    valueFormatter={(v) => `$${v}M`}
                                    yAxisLabel="Reported Dollars Sold ($M)"
                                />
                            </Grid>
                        </Grid>
                        <Grid container sx={{ mt: "34px !important" }}>
                            <Grid item xs={12}>
                                <LineChartSubBrand
                                    title={commodityVolumeBySubBrandData.title}
                                    xLabels={commodityVolumeBySubBrandData.xLabels}
                                    series={commodityVolumeBySubBrandData.series}
                                    dataMatrix={commodityVolumeBySubBrandData.dataMatrix}
                                    yTicks={[0, 20, 40, 60, 80, 100]}
                                    valueFormatter={(v) => `${v}M`}
                                    yAxisLabel="All Commodity Volume (%)"
                                />
                            </Grid>
                        </Grid>
                        <Grid container spacing={3} sx={{ mt: '34px !important' }}>
                            {/* LEFT CARD - USA MAP */}
                            <Grid item xs={12} md={6} sx={{
                                pt: { xs: "0px !important", sm: "0px !important", }
                            }}>
                                <TopSkuBarChart
                                    title={topSkuChartData.title}
                                    xLabels={topSkuChartData.xLabels}
                                    series={topSkuChartData.series}
                                    dataMatrix={topSkuChartData.dataMatrix}
                                    xTicks={[0, 50, 100, 200, 300]}
                                />

                            </Grid>

                            {/* RIGHT CARD - BAR CHART */}
                            <Grid item xs={12} md={6} sx={{
                                pt: { xs: "34px !important", sm: "34px !important", md: '0px !important' }
                            }}>
                                <TopSkuBarChart
                                    title={bottomSkuChartData.title}
                                    xLabels={bottomSkuChartData.xLabels}
                                    series={bottomSkuChartData.series}
                                    dataMatrix={bottomSkuChartData.dataMatrix}
                                    xTicks={[0, 10, 20, 30, 40]}
                                />

                            </Grid>
                        </Grid>
                        <Grid container sx={{ mt: "34px !important" }}>
                            <Grid item xs={12}>
                                <DoubleBarChart
                                    title={brandSalesChartData.title}
                                    xLabels={brandSalesChartData.xLabels}
                                    series={brandSalesChartData.series}
                                    dataMatrix={brandSalesChartData.dataMatrix}
                                    yTicks={[0, 1, 2, 3, 4, 5]}
                                />
                            </Grid>
                        </Grid>

                        <Grid container sx={{ mt: "34px !important" }}>
                            <Grid item xs={12}>
                                <BrandPriceDumbbellChart
                                    title={brandPriceComparison.title}
                                    xLabels={brandPriceComparison.xLabels}
                                    series={brandPriceComparison.series}
                                    dataMatrix={brandPriceComparison.dataMatrix}
                                    yTicks={brandPriceComparison.yTicks}
                                />
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Box>
        </DashboardLayout >
    );
}

export default RetailsDetailspage;
